export default {
  methods: {
    /**
     * @name customizeChangeHandler
     * @param value
     * @param control
     */
    customizeChangeHandler(value, control) {
      this.$emit('customizeChange', this, value, control)
    },

    /**
     * @name initOk
     */
    initOk() {
      this.$emit('ok', this)
    }
  }
}
